import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faPlus, faUndo } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import CreatableSelect from "react-select/creatable";
import { Redirect, Link } from "react-router-dom";
import apiUrl from "../apiUrlConstant";
//import Masters from "../masters/Masters";
import * as Yup from "yup";
//import AuthService from "../AuthService";
import { Alert } from "react-bootstrap";
import { PopupMessage } from "../utils/utils";

const loginForm = Yup.object().shape({
  password: Yup.string().required("Required"),
  cpassword: Yup.string()
    .required("Required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

class UserResetPassword extends React.Component {
  state = {
    redirect: false,
    showLoader: false,
    errorMessage: "",
    showAlert: false,
    setShow: false,
    messsagePopup: false,
    popupContent: "",
  };

  componentDidMount() {}

  constructor(props) {
    super(props);
  }
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, popupContent: "" });
  };

  render() {
    //console.log(this.props.match,"this.props.match.params.token");

    if (this.state.redirect == true) {
      let url = this.props.match;
      //this.state.redirect = false;
      return <Redirect push to="/login" />;
    }
    return (
      <div
        className="parentContainer"
        style={{
          float: "right",
          width: "100%",
          display: "block",
          overflowY: "auto",
          overflowX: "hidden",
          height: "100vh",
          backgroundImage: `url("/img/loginBackground.jpg")`,
          backgroundSize: "100% 100%",
          backgroundPosition: "center center",
        }}
      >
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <Formik
          validationSchema={loginForm}
          initialValues={{
            password: "",
            cpassword: "",
            resetToken: "",
          }}
          onSubmit={(values, actions, props) => {
            var ths = this;
            // ths.showLoader = true;
            this.setState({ showLoader: true });
            localStorage.setItem("cpassword", values.cpassword);
            localStorage.setItem("password", values.password);
            console.log(this.state.showLoader);
            var self = this;

            //console.log(this.props.match.params.token,"this.props.match.params.token")
            let paramString = window.location.href.split("/");
            let token = paramString[paramString.length - 1];
            values.resetToken = token;
            console.log(values, "valuesvaluesvalues");
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/user/reset-password`,
              data: values,
            }).then(function (response) {
              console.log(response.data, "response.data");
              self.setState({ showLoader: false });
              if (!response.data.result) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
                self.setState({
                  messsagePopup: true,
                  popupContent: "This Link is Expired. Please click on forgot password to reset password.",
                });
                //alert("Data Saved Successfully");
              } else {
                // alert("Data Saved Successfully");
                // self.setState({ redirect: true });
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!",
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainer login">
              <div className="container">
                <div className="row"></div>
              </div>
              <div>
                <div></div>
              </div>
              <Form autoComplete="off">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-5 mx-auto">
                      <div className="formContainer">
                        {/* <h1 className="text-center mb-3">Lease Matrix Login</h1> */}
                        <div className="inputContainer col-lg-12 col-md-12">
                          <h1 className="text-center">
                            <Link to={`/lease-summary`} className="">
                              <img src="/img/logo.png" className="logoImg" />
                            </Link>
                          </h1>
                          <p className="tagLine text-center">
                            TAKE CONTROL OF YOUR REAL ESTATE
                          </p>
                          <Alert
                            variant="danger"
                            onClose={() => this.setState({ showAlert: false })}
                            dismissible
                            show={this.state.showAlert}
                          >
                            <Alert.Heading>
                              {this.state.errorMessage}
                            </Alert.Heading>
                          </Alert>
                          <div className="row mb-3">
                            <label className="col-sm-12 col-form-label">
                              Password <span>*</span>
                            </label>
                            <div className="col-sm-12">
                              <Field type="password" name="password" />
                              <ErrorMessage
                                name="password"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-12 col-form-label">
                              Confirm Password <span>*</span>
                            </label>
                            <div className="col-sm-12">
                              <Field type="password" name="cpassword" />

                              <ErrorMessage
                                name="cpassword"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="inputContainer col-lg-12 col-md-12 marginBottom-0">
                          <div className="row">
                            <div className="col-sm-12">
                              <Link to={`/`} className="btnLink">
                                Login
                              </Link>

                              {this.state.showLoader && (
                                <p
                                  className="text-center mb-0"
                                  style={{ fontWeight: "600" }}
                                >
                                  <img src="/img/loading.gif" width={"80px"} />
                                </p>
                              )}
                              <button
                                type="submit"
                                className="loginBtn"
                                value="LOGIN"
                                onClick={(e) => {
                                  this.setState({ showAlert: false });
                                }}
                              >
                                Change Password
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="inputContainer col-lg-12 col-md-12 mt-4 madeBy marginBottom-0">
                          <div className="row">
                            <div className="col-sm-12 text-center">
                              <p>Made By</p>
                              <p className="marginBottom-0">
                                <img src="/img/cre-matrix-logo.png" />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </div>
    );
  }
}

export default UserResetPassword;
